module.exports = __webpack_public_path__ + "img/speak4.86ef8f98.png";